import React, { useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import _ from "lodash";

import columns from "./columns";

// Helpers
import NotAuthorized from "modules/5_view_helpers/web/NotAuthorized";
import HasRole from "modules/5_view_helpers/HasRole";
import Toggle from "modules/5_view_helpers/web/Toggle";

// Actions
import { getProjectAreas, archiveProjectArea, unarchiveProjectArea } from "../actions";
import TableTorch from "modules/5_view_helpers/web/TableTorch";

function mapStateToProps(state, ownProps) {
  const {
    project: { id: project_id },
  } = ownProps;

  let project_areas = {};
  if (project_id && _.isNotEmpty(state.project_areas)) {
    project_areas = _.filter(
      state.project_areas,
      (pa) => pa.project_id == project_id
    );
  }

  return {
    project_areas: project_areas,
    current_user: state.current_user,
  };
}

const ProjectAreaIndex = (props) => {
  const { project, onSelect, current_user } = props;
  const [showArchived, setShowArchived] = useState(false);

  const moderatorRole =
    current_user?.admin ||
    _.some(current_user?.roles, (r) => r.resource_type == "Project::Area" && r.name == "moderator");

  const readRole = HasRole({
    resource_type: "Project::Area",
    name: ["read", "moderator"],
  });
  const createRole = HasRole({
    resource_type: "Project::Area",
    name: ["create", "moderator"],
  });
  const updateRole = HasRole({
    resource_type: "Project::Area",
    name: ["update", "moderator"],
  });

  useEffect(() => {
    if (readRole && project?.id) {
      props.getProjectAreas(project.id, showArchived);
    }
  }, [readRole, project?.id, showArchived]);

  const { project_areas, showCreateButton, showFilters } = props;

  const displayedAreas = showArchived ? project_areas : _.filter(project_areas, (pa) => !pa.archived);

  const columnActions = {
    canArchive: moderatorRole,
    onArchive: (row) => {
      if (!project?.id) return;
      props.archiveProjectArea(project.id, row.id).then(() => {
        toastr.success("Area archived");
      });
    },
    onUnarchive: (row) => {
      if (!project?.id) return;
      props.unarchiveProjectArea(project.id, row.id).then(() => {
        toastr.success("Area restored");
      });
    },
  };

  if (!readRole) {
    return <NotAuthorized />;
  } else {
    return (
      <Card>
        <CardBody>
          <Fragment>
            <Row className="align-items-center">
              {createRole && showCreateButton && (
                <Col xs="auto">
                  <Link to={`/project/${project?.id}/areas/new`}>
                    <Button color="primary" size="md">
                      <i class_name="fa fa-plus"> Create New Area</i>
                    </Button>
                  </Link>
                </Col>
              )}
              <Col className="text-right">
                <Toggle checked={showArchived} onClick={() => setShowArchived(!showArchived)} label="Show archived areas" />
              </Col>
            </Row>

            <Row className="mt-2">
              <Col>
                <TableTorch
                  columns={columns(updateRole, columnActions)}
                  data={displayedAreas}
                  showFilters={showFilters}
                  selectable
                  onSelect={onSelect}
                />
              </Col>
            </Row>
          </Fragment>
        </CardBody>
      </Card>
    );
  }
};

ProjectAreaIndex.defaultProps = {
  showCreateButton: true,
  showFilters: true,
};

export default connect(mapStateToProps, { getProjectAreas, archiveProjectArea, unarchiveProjectArea })(ProjectAreaIndex);

